import React from 'react'
import Loadable from 'react-loadable'

export const LoadableLogin = Loadable({
  loader: () => import(/* webpackChunkName: "/Login" */ 'pages/Login'),
  loading() {
    return <div>Loading...</div>
  },
})

export const LoadableNewsFeed = Loadable({
  loader: () => import(/* webpackChunkName: "/NewsFeed" */ 'pages/NewsFeed'),
  loading() {
    return <div>Loading...</div>
  },
})

export const LoadableCampaignDetail = Loadable({
  loader: () => import(/* webpackChunkName: "/CampaignDetail" */ 'pages/CampaignDetail'),
  loading() {
    return <></>
  },
})

export const LoadableImprovingSales = Loadable({
  loader: () => import(/* webpackChunkName: "/ImprovingSales" */ 'pages/ImprovingSales'),
  loading() {
    return <></>
  },
})

export const LoadableTasksList = Loadable({
  loader: () => import(/* webpackChunkName: "/TasksList" */ 'pages/HubEntityList'),
  loading() {
    return <div>Loading...</div>
  },
})

export const LoadableTask = Loadable({
  loader: () => import(/* webpackChunkName: "/Task" */ 'components/Tasks/Task'),
  loading() {
    return <div>Loading...</div>
  },
})

export const LoadableCustomReports = Loadable({
  loader: () => import(/* webpackChunkName: "/CustomReports" */ 'pages/CustomReports'),
  loading() {
    return <div>Loading...</div>
  },
})
export const LoadableReports = Loadable({
  loader: () => import(/* webpackChunkName: "/Reports" */ 'pages/Reports'),
  loading() {
    return <div>Loading...</div>
  },
})

export const LoadableTasksOverview = Loadable({
  loader: () => import(/* webpackChunkName: "/TasksOverview" */ 'pages/TasksOverview'),
  loading() {
    return <></>
  },
})

export const LoadableNewTaskDashboard = Loadable({
  loader: () => import(/* webpackChunkName: "/NewTaskDashboard" */ 'pages/NewTaskDashboard'),
  loading() {
    return <></>
  },
})

export const LoadableTasksOverviewDetail = Loadable({
  loader: () => import(/* webpackChunkName: "/TasksOverviewDetail" */ 'pages/TasksOverviewDetail'),
  loading() {
    return <></>
  },
})

export const LoadableTasksOverviewSubtasks = Loadable({
  loader: () => import(/* webpackChunkName: "/TasksOverviewSubtasks" */ 'pages/TasksOverviewSubtasks'),
  loading() {
    return <></>
  },
})

export const LoadableTaskViews = Loadable({
  loader: () => import(/* webpackChunkName: "/TaskViews" */ 'pages/TaskViews'),
  loading() {
    return <></>
  },
})

export const LoadableTaskViewsTasks = Loadable({
  loader: () => import(/* webpackChunkName: "/TaskViewsTasks" */ 'pages/TaskViewsTasksPage'),
  loading() {
    return <></>
  },
})

export const LoadableTaskViewsRsc = Loadable({
  loader: () => import(/* webpackChunkName: "/TaskViewsRsc" */ 'pages/TaskViewsRscPage'),
  loading() {
    return <></>
  },
})

export const LoadableTaskViewsSvc = Loadable({
  loader: () => import(/* webpackChunkName: "/TaskViewsSvc" */ 'pages/TaskViewsSvcPage'),
  loading() {
    return <></>
  },
})

export const LoadableRanking = Loadable({
  loader: () => import(/* webpackChunkName: "/Ranking"  */ 'pages/Ranking'),
  loading() {
    return <></>
  },
})

export const LoadableRankingsList = Loadable({
  loader: () => import(/* webpackChunkName: "/RankingsList"  */ 'pages/RankingsList'),
  loading() {
    return <></>
  },
})

export const LoadableIntegrations = Loadable({
  loader: () => import(/* webpackChunkName: "/Integrations"  */ 'pages/Integrations'),
  loading() {
    return <></>
  },
})

export const LoadableServiceCallsDashboard = Loadable({
  loader: () => import(/* webpackChunkName: "/ServiceCallsDashboard"  */ 'pages/ServiceCallsDashboard'),
  loading() {
    return <></>
  },
})

export const LoadableAnalytics = Loadable({
  loader: () => import(/* webpackChunkName: "/Analytics"  */ 'pages/Analytics'),
  loading() {
    return <></>
  },
})

export const LoadableSetup = Loadable({
  loader: () => import(/* webpackChunkName: "/Setup"  */ 'pages/Setup'),
  loading() {
    return <></>
  },
})

export const LoadableSalesOpportunities = Loadable({
  loader: () => import(/* webpackChunkName: "/SalesOpportunities"  */ 'pages/SalesOpportunites'),
  loading() {
    return <></>
  },
})

export const LoadableOrgnizationTree = Loadable({
  loader: () => import(/* webpackChunkName: "/OrgnizationTree"  */ 'pages/OrgnizationTree'),
  loading() {
    return <></>
  },
})

export const LoadableTasksAnalyticsDashboard = Loadable({
  loader: () => import(/* webpackChunkName: "/TasksAnalyticsDashboard"  */ 'pages/TasksAnalyticsDashboard'),
  loading() {
    return <></>
  },
})

export const LoadableProductPerformance = Loadable({
  loader: () => import(/* webpackChunkName: "/ProductPerformance" */ 'pages/ProductPerformance'),
  loading() {
    return <></>
  },
})

export const LoadableCreateTaskV2 = Loadable({
  loader: () => import(/* webpackChunkName: "/CreateTaskV2"  */ 'pages/CreateTaskV2'),
  loading() {
    return <></>
  },
})

export const LoadableExternalIframePage = Loadable({
  loader: () => import(/* webpackChunkName: "/ExternalIframePage" */ 'pages/ExternalIframePage'),
  loading() {
    return <div>Loading...</div>
  },
})

export const LoadableMySchedules = Loadable({
  loader: () => import(/* webpackChunkName: "/MySchedules" */ 'components/MySchedules'),
  loading() {
    return <></>
  }
})

export const LoadableLibrary = Loadable({
  loader: () => import(/* webpackChunkName: "/Library" */ 'pages/Library'),
  loading() {
    return <></>
  }
})

export const LoadableAgentPage = Loadable({
  loader: () => import(/* webpackChunkName: "/AgentPage" */ 'pages/AgentPage'),
  loading() {
    return <></>
  },
})
